import React, { useEffect } from "react";
import { HashRouter as Router } from "react-router-dom";
import Header from "./components/header";
import { useStore } from "./store";
import Container from "./containers";
import Notification from "./components/notification";
const App: React.FC = () => {
  const { quotesStore } = useStore();
  const { setScreenWidth } = quotesStore;

  useEffect(() => {
    setScreenWidth(window.innerWidth);
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [setScreenWidth]);

  return (
    <div className="h-full w-full flex-col justify-center">
      <Notification />
      <Router>
        <Header />
        <Container />
      </Router>
    </div>
  );
};

export default App;
